import axiosClient from '@/services/axios';
import { getContents } from '@/url/content';

export const contentsAPI = async (filters) => {
  const url = getContents(filters);
  try {
    const response = await axiosClient.get(url);
    return response?.data?.data || [];
  } catch (error) {
    console.log({ error });
  }
};

export const contentsAPIV2 = async (filters) => {
  const url = getContents(filters);
  try {
    const response = await axiosClient.get(url);
    return response?.data?.data;
  } catch (error) {
    console.log({ error });
  }
};

export const otherContentAPI = () => {};
